
import React from "react";

import {ModalWrapper, Reoverlay} from "reoverlay";
import 'reoverlay/lib/ModalWrapper.css';
import {BsTrash3} from "react-icons/bs";
import Button from "../Button";

const ConfirmDeleteWidgetModal=(props)=>{


    const onDelete=()=>{
        props.onDelete();
        Reoverlay.hideModal()
    }

    const onBack=()=>{
            props.onBack();
            Reoverlay.hideModal()
    }

    return <ModalWrapper onClose={()=>{}}  animation="slideDown" contentContainerClassName="w-11/12 md:8/12 lg:w-4/12 p-5 rounded-xl">
        <div className="flex justify-center">
            < BsTrash3 className="text-4xl text-red-500 mb-5 "/>
        </div>
        <h1 className="text-center  font-bold text-xl    mb-2  ">{props.title || 'آیا مطمئن هستید؟'}</h1>
        <p className="text-center    pb-5 mb-8  text-sm border-gray-100">{props.description||'چهره شما از روی این آگهی حذف خواهد شد. آیا مطمئن هستید؟'}</p>

        <div className="grid grid-cols-2 gap-2 mt-5">
            <Button className="text-sm" onClick={onDelete} rounded="rounded-xl" theme="red">{props.confirmButtonText ||'حذف چهره فعلی'}</Button>
            <Button className="text-sm" onClick={onBack}  theme="light" rounded="rounded-xl" >{props.cancelButtonText || 'بازگشت'}</Button>

        </div>



    </ModalWrapper>
}
export default ConfirmDeleteWidgetModal;